<template>
	<div class="order-main-info">
		<requestor-info />
		<work-order-info/>
		<b-row>
			<b-col md="6" class="pr-md-2">
				<supplier-info />
			</b-col>
			<b-col md="6" class="pl-md-2">
				<fm-officer />
			</b-col>
		</b-row>
        <order-line-item @reload-order="reloadGetOrder" @orderNeedApproval="checkOrderNeedApproval" ref="orderLineItems" />
	  	<gofix-attachment
			:create-role="!IsReadOnly && $checkRole(this.$accessModule.order_tabs.main_info, 'create')"
			:update-role="!IsReadOnly && $checkRole(this.$accessModule.order_tabs.main_info, 'update')"
			:delete-role="!IsReadOnly && $checkRole(this.$accessModule.order_tabs.main_info, 'delete')"
			:Item="Item" :attachable_type="'order'"
			title="Attachments"
			classContentCard="mb-0"
			:isFixed="false" />
		<b-row>
			<b-col md="6" class="pr-md-2">
				<completed-by />
			</b-col>
			<b-col md="6" class="pl-md-2">
				<accepted-by />
			</b-col>
		</b-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
//Import component
const requestorInfo = () => import("./main-info/requestor-info")
const workOrderInfo = () => import("./main-info/work-order-info")
const supplierInfo = () => import("./main-info/supplier-info")
const fmOfficer = () => import("./main-info/fm-officer")
const completedBy = () => import("./main-info/completed-by")
const acceptedBy = () => import("./main-info/accepted-by")
const orderLineItem = () => import("./main-info/order-line-items")

export default {
	name: 'main-info-order',
	components: {
		requestorInfo,
		workOrderInfo,
		supplierInfo,
		fmOfficer,
		completedBy,
		acceptedBy,
        orderLineItem
  	},
	data () {
		return {}
	},
	watch: {},
	computed: {
		...mapGetters({
			Item: 'OrderController/Item',
			IsReadOnly: 'OrderController/IsReadOnly',
		})
	},
	created() {},
	methods: {
		reloadOrderItem(){
			this.$refs.orderLineItems.reloadLineItemData()
		},
		reloadGetOrder(){
			this.$emit('reloadorder');
		},
		checkOrderNeedApproval(val) {
			this.$emit("orderNeedApproval", val)
		}
	},
}
</script>
